var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 150,
    height: 150,
    fill: "#fff7ed"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 80,
    r: 10,
    fill: "gray"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    from: 10,
    to: 15,
    dur: "2s",
    begin: "0s",
    repeatCount: "indefinite",
    values: "10; 15; 10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtPlaceholder);
export default __webpack_public_path__ + "static/media/ArtPlaceholder.df1fedc4d4ebc26adbef3cfb0f2c5887.svg";
export { ForwardRef as ReactComponent };